import React, { useState, useRef, useEffect } from "react";
import logo from "../../logo/temoc.png";
import { Link } from "react-router-dom";
import Modal from "./Modal"

function TemocBotWithModel() {
  const [query, setQuery] = useState("");
  const [messages, setMessages] = useState([{
    isUser: false,
    content: 'Hi! Ask me anything...'
  }]);

  const messagesEndRef = useRef(null)
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" })
  }
  useEffect(() => {
    scrollToBottom()
  }, [messages]);

  function submitMessage(msg) {
    setMessages(messages => [...messages, {
      isUser: true,
      content: msg
    }]);
    setQuery("");
    fetch(`https://3636-2600-3c00-00-f03c-93ff-fefe-dad0.ngrok.io/model-result?question=${msg}`, {
      headers: {
        "ngrok-skip-browser-warning": true
      }
    })
      .then(response => response.json())
      .then(msg => {
        setMessages(messages => [...messages, {
          isUser: false, content: msg.answer
        }])
      })
  }

  return (
    <div className='flex flex-col h-screen'>
      <Modal/>
      <div className='flex mt-8'>
        <p className='mt-2 ml-2 xl:ml-20 text-orange-500 text-3xl xl:text-7xl font-bold'>
          Temoc
        </p>
        <p className='mt-2 text-teal-900 text-3xl xl:text-7xl font-bold'>
          Talk
        </p>
        <Link to={'/chat'}>
          <img className="w-12 xl:w-28" src={logo} alt="logo" />
        </Link>
        <div className='self-center w-full text-xl font-bold opacity-60 text-end xl:mr-20'>
          <Link to={'/'}>
            Back
          </Link>
        </div>
      </div>
      <div className={'bg-orange-500 xl:mr-20 xl:ml-20 mt-5 text-white font-semibold text-center text-xl xl:text-2xl py-8 px-4 duration-300 transition-all ' + (messages.length >= 3 ? 'hidden' : 'block')}>
          Welcome to TemocTalk! <br/>
          Ask any admission related question and let us help.
      </div> 
     <div className='bg-gray-200 xl:mr-20 xl:ml-20 h-full flex flex-col py-4 overflow-scroll'>
          {messages.map((message, idx) => {
            if (message.isUser) {
              return (
                <div key={idx} className='px-8 py-4 mx-4 my-2 rounded-xl bg-blue-400 max-w-xl self-end text-xl'>
                  {message.content}
                </div>
              )
            } else {
              return (
                <div key={idx} className='px-8 py-4 mx-4 my-2 rounded-xl bg-gray-400 max-w-xl self-start text-xl'>
                  {message.content}
                </div>
              )
            }
          })}
          <div ref={messagesEndRef} />
      </div>
      <input 
        className='bg-emerald-400 h-40 xl:mr-20 xl:ml-20 text-green-900 p-2 rounded-none placeholder-green-700 outline-none text-xl px-10 mb-20'
        value={query}
        placeholder={"Enter your question here..."}
        onChange={e => {
          setQuery(e.target.value);
        }}
        onKeyPress={e => {
          if (e.key === 'Enter' && query !== '') {
            submitMessage(query);
          }
        }}
      />
    </div>
  );
}

export default TemocBotWithModel;
